<template>
  <div class="profile-page" style="
    height: 100%; 
    background: linear-gradient(135deg, rgba(245, 246, 246, 0.6) 0%, rgba(232, 250, 255, 0.6) 50%, rgba(157, 224, 245, 0.6) 100%); 
    position:relative; 
    color:#000;
    z-index: 1;
    ">
    <span style="position: absolute; top: 0; right: 0; padding: 0.25em 0.5em; cursor: pointer;" @click="toggle">
      <i class="material-icons" style="color: #000;">close</i>
    </span>
    <div
      style="display: flex; justify-content: space-between; align-items: center; padding:0.5em 2em; border-bottom: 0.1em solid #00000020; padding-top : 2em;">
      <div style="display: flex; align-items: center;">
        {{ this.$i18n.t('user_profile.audio_active') }}
      </div>
      <div style="display: flex; align-items: center;">
        <ToggleSwitch :value="this.$store.state.navigation.audioSound" :toggle="change_audio_mode"></ToggleSwitch>
      </div>
    </div>
    <div
      style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding:0.5em 2em; border-bottom: 0.1em solid #00000020; gap:0.5em">
      <div style="display: flex; align-items: center;"><strong>
          {{ this.$i18n.t('user_profile.score.title') }}
        </strong></div>
      <div
        style="display:flex; justify-content: space-between; flex-direction: row; flex:1; width:100%; gap:0.25em; padding:0; margin:0">
        <div
          style="display:flex; align-items: center; justify-content: center; flex-direction: column; padding:0; height: fit-content;">
          <h5 style="margin:0.25em 0.5em">
            {{ this.$i18n.t('user_profile.score.intro_qcm') }}
          </h5>
          <h3 style="margin:0.25em 0.5em">
            {{ !isNaN(introScore?.percentage?.correctAnswers) ? `${introScore?.percentage?.correctAnswers}%` : '--' }}
          </h3>
        </div>
        <div
          style="display:flex; align-items: center; justify-content: center; flex-direction: column; padding:0; height: fit-content;">
          <h5 style="margin:0.25em 0.5em">
            {{ this.$i18n.t('user_profile.score.exit_qcm') }}
          </h5>
          <h3 style="margin:0.25em 0.5em">
            {{ !isNaN(outroScore?.percentage?.correctAnswers) ? `${outroScore?.percentage?.correctAnswers}%` : '--' }}
          </h3>
        </div>
      </div>
    </div>
    <div
      style="display: flex; flex-direction:column; justify-content: space-between; align-items: center; padding:0.75em 2em; border-bottom: 0.1em solid #00000020; gap:1em">
      <div style="width:100%; display:flex; flex-direction:column">
        <div style="width:100%; display:flex; justify-content: space-between;">
          <div style="display: flex; align-items: center;"> {{ this.$i18n.t('user_profile.subscription_date') }} </div>
          <div style="display: flex; align-items: center;">
            {{ userSubscriptionDetails.displayedDate }}
          </div>
        </div>
        <div style="font-size: 0.75em" v-if="userSubscriptionDetails.hasSubscriptionMonthly">
          {{
            this.$i18n.t('user_profile.monthly_subscription') + " " + subscriptionType
          }}
          <button style="color:red; text-decoration:underline"
            @click="stopSubscription"
          >
            {{ this.$i18n.t('user_profile.deactivate_subscription') }}
          </button>
        </div>
        <div style="font-size: 0.75em" v-else>
          {{
            this.$i18n.t('user_profile.no_subscription') + " " + subscriptionType
          }}
        </div>
      </div>
      <div style="width:100%; display:flex; justify-content: space-between;">
        <div style="display: flex; align-items: center;"> {{ this.$i18n.t('user_profile.level') }} </div>
        <div style="display: flex; align-items: center;">
          {{ getLevel }}
        </div>
      </div>

      <div style="width:100%; display:flex; justify-content: space-between;">
        <div style="display: flex; align-items: center;">
          {{ this.$i18n.t('user_profile.leve_choice') }}
        </div>
        <div style="display: flex; align-items: center;">
          <select v-model="selectedDifficulty" @change="updateDifficulty" style="width: 10em"
            :disabled="isNaN(introScore?.correctAnswers)"
            :title="isNaN(introScore?.correctAnswers) ? this.$i18n.t('user_profile.finish_into_first') : ''">
            <option v-for="(level, i) in Object.values(resultPercentages)" :key="i" :value="level.levelNumber">
              {{ level.text[lang] }} {{ level.emoji }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div
      style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding:1em 2em; border-bottom: 0.1em solid #00000020; gap:0.5em">
      <button
        style="background: transparent; border: 1px solid #000; border-radius: 50px; padding: 0.5em; width: 12.5em; text-align: center;"
        @click="malito('virginie@formacast.org')">
        {{ this.$i18n.t('user_profile.action_buttons.my_content') }}
      </button>
      <!-- TODO link to site -->
      <button
        style="background: transparent; border: 1px solid #000; border-radius: 50px; padding: 0.5em; width: 12.5em; text-align: center;"
        @click="malito('virginie@formacast.org')">
        {{ this.$i18n.t('user_profile.action_buttons.my_subscription') }}
      </button>
      <!-- TODO link to stripe -->
      <button
        style="background: transparent; border: 1px solid #000; border-radius: 50px; padding: 0.6em; width: 12.5em; text-align: center;"
        @click="log_out">
        {{ this.$i18n.t('user_profile.action_buttons.logout') }}
      </button>
    </div>
    <div style="text-align: center; margin-bottom: 1.5em; padding-bottom:2.5em">
      <div style="text-align: center; margin-top: 1.5em;">
        <p>{{ this.$i18n.t('user_profile.footer') }}</p>
        <a href="mailto:contact@formacast.org">contact@formacast.org</a>
      </div>
    </div>

  </div>
</template>
<script>
import ToggleSwitch from "../customs/ToggleSwitch_Formacast.vue";
export default {
  name: "ProfilePage",
  components: {
    ToggleSwitch,
  },
  props: {
    toggle: {
      type: Function,
      default: () => { },
    },
  },
  data() {
    return {
      resultPercentages: {
        level1: { min: 0, max: 29, text: { fr: "Débutant", en: "Beginner" }, emoji: "🌱", levelNumber: 1 },
        level2: { min: 30, max: 59, text: { fr: "Intermédiaire", en: "Intermediate" }, emoji: "📚", levelNumber: 2 },
        level3: { min: 60, max: 89, text: { fr: "Confirmé", en: "Advanced" }, emoji: "🎓", levelNumber: 3 },
        level4: { min: 90, max: 100, text: { fr: "Expert", en: "Expert" }, emoji: "🚀", levelNumber: 4 }
      },
      selectedDifficulty: 1,
    };
  },
  computed: {
    introScore() {
      return this.$store.state.user?.data?.intro_exit_results?.SAI
    },
    outroScore() {
      return this.$store.state.user?.data?.intro_exit_results?.SAO
    },
    lang() {
      return this.$store.state.user.lang
    },
    getLevel() {
      let level = 1;
      let levelText = "";
      let levelEmoji = "";
      if (!this.introScore && !this.outroScore) {
        level = this.resultPercentages[`level${level}`];
        levelText = level.text[this.lang];
        levelEmoji = level.emoji;
        return `${levelEmoji} ${levelText}`;
      }
      if (this.introScore?.level) {
        level = this.resultPercentages[`level${this.introScore?.level}`];
      } else if (this.outroScore?.level) {
        level = this.resultPercentages[`level${this.outroScore?.level}`];
      } else if (this.introScore?.level && this.outroScore?.level) {
        if (this.introScore?.level > this.outroScore?.level) {
          level = this.resultPercentages[`level${this.introScore?.level}`];
        } else {
          level = this.resultPercentages[`level${this.outroScore?.level}`];
        }
      }
      levelText = level.text[this.lang];
      levelEmoji = level.emoji;
      this.selectedDifficulty = level.levelNumber;
      return `${levelEmoji} ${levelText}`;
    },
    userSubscriptionDetails() {
      const subscription = this.$store.state.user?.data?.subscription;
      return {
        ...subscription,
        displayedDate : new Date(subscription?.subs_started_at).toLocaleDateString(),
        hasSubscriptionMonthly: subscription?.method == "monthly" && subscription?.subscriptionId,
      }
    },
    subscriptionType() {
      return `${this.$store.state.user?.data?.subscription?.expected_work_hours / 3600000}h`
    },
  },
  methods: {
    change_audio_mode() {
      this.$store.state.navigation.audioSound = !this.$store.state.navigation.audioSound;
      this.settingsMenuOn = !this.settingsMenuOn;
    },
    log_out() {
      this.$store.dispatch("LOGOUT");
    },
    stopSubscription() {
      this.$store.dispatch("STOP_SUBSCRIPTION", { message: this.$i18n.t('chat.subscription.stop.confirmation') });
    },
    
    async updateDifficulty() {
      try {
        this.$store.dispatch("SET_MODAL", {
          body: this.$i18n.t('user_profile.difficulty_change_loading'),
          type: "loader"
        })
        await this.$store.dispatch('UPDATE_DIFFICULTY', { difficulty: this.selectedDifficulty });
        setTimeout(async () => {
          this.$store.dispatch("SET_MODAL", {
            body: this.$i18n.t('user_profile.difficulty_change_success'),
            type: "success",
          });
          
        }, 500);
      } catch (e) {
        this.$store.dispatch("SET_MODAL", {
          body: this.$i18n.t('user_profile.difficulty_change_error'),
          type: "error",
        });
      }
    },
    malito(email) {
      window.open(`mailto:${email}`);
    }
  },
};
</script>